import { useMemo } from 'react'

import { DEFAULT_SENDER_ID_NAME, DEFAULT_SENDER_ID_VALUE } from '@/app/definitions'
import { SenderIdOption } from '@/app/module/campaigns/types'

import { useGetSenderIds } from './use-get-sender-ids'

export const useGetSenderOptions = () => {
  const result = useGetSenderIds()

  const senderIds = useMemo<SenderIdOption[]>(() => {
    const data = result.data
    const source = Array.isArray(data) ? data : data?.sms || []

    return [
      {
        label: DEFAULT_SENDER_ID_NAME,
        value: DEFAULT_SENDER_ID_VALUE,
        type: 'sender',
      },
      ...source.map(
        ({ phonenumber, sender, name }): SenderIdOption => ({
          label: name ? `${name} (${sender || phonenumber})` : sender || phonenumber,
          value: sender || phonenumber,
          type: sender ? 'sender' : 'phonenumber',
        }),
      ),
    ]
  }, [result.data])

  return {
    senderIds,
    isLoading: result.isLoading,
  }
}
